import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;
// eslint-disable-next-line import/no-extraneous-dependencies
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Yup from 'yup';
import { PublicationStatus } from '@uno/common-cms';
import DateInput from 'components/common/DateInput';
import { PublishedStatus, ScheduleActionButton } from '..';
import { Content, Description, Form, Title } from '../PublishDialog.style';

var SchedulePublication = function SchedulePublication(_ref) {
  var publicationStatus = _ref.publicationStatus,
      scheduledDate = _ref.scheduledDate,
      handleChange = _ref.handleChange,
      onConfirm = _ref.onConfirm,
      onBack = _ref.onBack;
  var intl = useIntl();
  var formRef = useRef(null);

  var _useState = useState(false),
      isDateValid = _useState[0],
      setIsDateValid = _useState[1];

  var scheduledInputName = 'scheduledDate';
  var methods = useForm({
    resolver: yupResolver(Yup.object().shape(_defineProperty({}, scheduledInputName, Yup.date().min(new Date(), 'publish-modal.scheduled.error').required('form.required'))))
  });
  useEffect(function () {
    setIsDateValid(scheduledDate !== undefined);
  }, [scheduledDate]);

  var catchChange = function catchChange(choosenDate) {
    setIsDateValid(choosenDate !== undefined);
    handleChange(choosenDate);
  };

  return __jsx(React.Fragment, null, __jsx(PublishedStatus, {
    publicationStatus: publicationStatus
  }), __jsx(FormattedMessage, {
    id: "publish-modal.title",
    tagName: Title
  }), __jsx(FormattedMessage, {
    id: publicationStatus === PublicationStatus.SCHEDULED ? 'publish-modal.scheduled.schedule' : 'publish-modal.offline.schedule',
    tagName: Description
  }), __jsx(FormProvider, methods, __jsx(Form, {
    ref: formRef
  }, __jsx(Content, null, __jsx(DateInput, {
    name: scheduledInputName,
    label: intl.formatMessage({
      id: 'publish-modal.scheduled.date-time'
    }),
    defaultValue: scheduledDate,
    withTime: true,
    options: {
      disablePast: true,
      handleChange: catchChange
    }
  }), __jsx(ScheduleActionButton, {
    publicationStatus: publicationStatus,
    onConfirm: onConfirm,
    onBack: onBack,
    disabled: isDateValid === false
  })))));
};

export default SchedulePublication;